import Player from '@maersk-global/player-core';
import { PlayerOptions } from '@maersk-global/player-core/Player';

// Wrapper around MGs player, that handles updating current time
// When the player is not playing (or paused), it will still update the time in the requested time intervals to Date.now()
// Default is to update to date.Now() once a minute
export class TimeController
{
    player: Player;

    constructor(playerOptions: PlayerOptions, interval: number = 60*1000)
    {
        this.player = new Player(playerOptions);
        this.player.currentTime = Date.now();

        this._intervalId = setInterval(() => {
            if (!this.player.playing && this.player.currentTime < Date.now())
            {
                this.player.currentTime = Date.now();
            }
        }, interval);
    }

    destroy()
    {
        // Stop timer
        clearInterval(this._intervalId);
    }

    private _intervalId: number;
}
